import { Industry } from '@clipr/lib';
import { DropdownItemObject } from '../../components/input/dropdownInput';
import { camelPad } from '../../core/string';

export type JobIndustry = Industry;

 
// The list of selectable industries deliberately excludes the deprecated misspelled
// 'AccomodationFoodServices': stored records may still carry it (getJobIndustryLabel keeps
// rendering it), but every new selection writes the corrected value.
export const JobIndustry: JobIndustry[] = [
  'AccommodationFoodServices',
  'AdministrationBusinessWasteServices',
  'AgricultureForestryFishingHunting',
  'ArtsEntertainmentRecreation',
  'Construction',
  'EducationalServices',
  'FinanceInsurance',
  'HealthcareSocialAssistance',
  'Information',
  'Manufacturing',
  'Mining',
  'OtherServices',
  'ProfessionalScientificTechnicalServices',
  'PublicSafety',
  'RealEstateRentalLeasing',
  'RetailTrade',
  'TransportationWarehousing',
  'Utilities',
  'WholesaleTrade',
];

export const getJobIndustryLabel = (industry: Industry): string => {
  switch (industry) {
    case 'AccomodationFoodServices':
      return 'Accommodation Food Services';
    case 'AccommodationFoodServices':
    case 'AdministrationBusinessWasteServices':
    case 'AgricultureForestryFishingHunting':
    case 'ArtsEntertainmentRecreation':
    case 'Construction':
    case 'EducationalServices':
    case 'FinanceInsurance':
    case 'HealthcareSocialAssistance':
    case 'Information':
    case 'Manufacturing':
    case 'Mining':
    case 'OtherServices':
    case 'ProfessionalScientificTechnicalServices':
    case 'RealEstateRentalLeasing':
    case 'RetailTrade':
    case 'TransportationWarehousing':
    case 'Utilities':
    case 'WholesaleTrade':
    case 'PublicSafety':
    default:
      return camelPad(industry);
  }
}

export const getDefaultJobIndustry = (): Industry => {
  return 'PublicSafety';
}

export const getJobIndustryInputLabel = (): string => {
  return 'Industry';
}

export const SpecialityItems: DropdownItemObject[] = JobIndustry
  .map(item => ({ value: item, label: getJobIndustryLabel(item) }));

/**
 * Selector items for an editor that may hold a stored value. A record saved with the deprecated
 * 'AccomodationFoodServices' spelling must still render as selected — with no matching option the
 * select falls back to the empty entry and the stored industry reads as unset — but the deprecated
 * value is never offered otherwise, so every new selection writes the corrected spelling.
 */
export const getJobIndustryItems = (current?: string | null): DropdownItemObject[] => {
  if (current === 'AccomodationFoodServices') {
    return [{ value: current, label: getJobIndustryLabel(current) }, ...SpecialityItems];
  }
  return SpecialityItems;
};

export const DefaultJobIndustryItem: DropdownItemObject | null = SpecialityItems.find(({ value }) => value === getDefaultJobIndustry()) || null;
